
export const AppMenus = {
    
	navbarTopRight: [],
	navbarTopLeft: [
  {
    "to": "/users",
    "label": "Users",
    "icon": "pi pi-users",
    "iconcolor": "",
    "target": "",
    
  },
  {
    "to": "/tariffs",
    "label": "Tariffs",
    "icon": "",
    "iconcolor": "",
    "target": "",
    
  },
  {
    "to": "/payments",
    "label": "Payments",
    "icon": "",
    "iconcolor": "",
    "target": "",
    
  },
  {
    "to": "/alerts",
    "label": "Alerts",
    "icon": "",
    "iconcolor": "",
    "target": "",
    
  },
  {
    "to": "/messages",
    "label": "Messages",
    "icon": "",
    "iconcolor": "",
    "target": "",
    
  },
  {
    "to": "/meterreadings",
    "label": "Meter Readings",
    "icon": "",
    "iconcolor": "",
    "target": "",
    
  },
  {
    "to": "/rentbills",
    "label": "Rent Bills",
    "icon": "",
    "iconcolor": "",
    "target": "",
    
  },
  {
    "to": "/waterbills",
    "label": "Water Bills",
    "icon": "",
    "iconcolor": "",
    "target": "",
    
  },
  {
    "to": "/tenancy",
    "label": "Tenancy",
    "icon": "",
    "iconcolor": "",
    "target": "",
    
  },
  {
    "to": "/customeraccount",
    "label": "Customer Account",
    "icon": "",
    "iconcolor": "",
    "target": "",
    
  }
],
	navbarSideLeft: [
  {
    "to": "/home",
    "label": "Home",
    "icon": "pi pi-home",
    "iconcolor": "",
    "target": "",
    
  },
  {
    "to": "/houses",
    "label": "Houses",
    "icon": "pi pi-home",
    "iconcolor": "",
    "target": "_parent",
    
  },
  {
    "to": "/customers",
    "label": "Customers",
    "icon": "pi pi-users",
    "iconcolor": "",
    "target": "",
    
  },
  {
    "to": "/tenancy",
    "label": "Tenancy",
    "icon": "pi pi-info",
    "iconcolor": "",
    "target": "",
    
  },
  {
    "to": "/customeraccount",
    "label": "Customer Account",
    "icon": "pi pi-wallet",
    "iconcolor": "",
    "target": "",
    
  },
  {
    "to": "/billingperiods",
    "label": "Billing Periods",
    "icon": "pi pi-th-large",
    "iconcolor": "",
    "target": "",
    
  },
  {
    "to": "/users",
    "label": "Users",
    "icon": "pi pi-users",
    "iconcolor": "",
    "target": "",
    
  },
  {
    "to": "/payments",
    "label": "Payments",
    "icon": "pi pi-money-bill",
    "iconcolor": "",
    "target": "",
    
  },
  {
    "to": "/meters",
    "label": "Meters",
    "icon": "pi pi-th-large",
    "iconcolor": "",
    "target": "",
    
  },
  {
    "to": "/meterreadings",
    "label": "Meter Readings",
    "icon": "pi pi-eye",
    "iconcolor": "",
    "target": "",
    
  },
  {
    "to": "/tariffs",
    "label": "Tariffs",
    "icon": "pi pi-tag",
    "iconcolor": "",
    "target": "",
    
  },
  {
    "to": "/combinedbillsview",
    "label": "Combined Bills View",
    "icon": "pi pi-money-bill",
    "iconcolor": "",
    "target": "",
    
  },
  {
    "to": "/waterbills",
    "label": "Water Bills",
    "icon": "pi pi-money-bill",
    "iconcolor": "",
    "target": "",
    
  },
  {
    "to": "/rentbills",
    "label": "Rent Bills",
    "icon": "pi pi-money-bill",
    "iconcolor": "",
    "target": "",
    
  },
  {
    "to": "/depositrefunds",
    "label": "Deposit Refunds",
    "icon": "pi pi-minus-circle",
    "iconcolor": "",
    "target": "",
    
  },
  {
    "to": "/deposits",
    "label": "Deposits",
    "icon": "pi pi-plus-circle",
    "iconcolor": "",
    "target": "",
    
  },
  {
    "to": "/deposittypes",
    "label": "Deposit Types",
    "icon": "pi pi-plus-circle",
    "iconcolor": "",
    "target": "",
    
  },
  {
    "to": "/depositdeductions",
    "label": "Deposit Deductions",
    "icon": "pi pi-filter-fill",
    "iconcolor": "",
    "target": "",
    
  },
  {
    "to": "/billingtype",
    "label": "Billing Type",
    "icon": "pi pi-th-large",
    "iconcolor": "",
    "target": "",
    
  },
  {
    "to": "/alerts",
    "label": "Alerts",
    "icon": "pi pi-th-large",
    "iconcolor": "",
    "target": "",
    
  },
  {
    "to": "/messages",
    "label": "Messages",
    "icon": "pi pi-th-large",
    "iconcolor": "",
    "target": "",
    
  },
  {
    "to": "/tenancy/inactive",
    "label": "Inactive",
    "icon": "pi pi-th-large",
    "iconcolor": "",
    "target": "",
    
  },
  {
    "to": "/tenancy/active",
    "label": "Active",
    "icon": "pi pi-th-large",
    "iconcolor": "",
    "target": "",
    
  }
],
	status: [    
{value: "Open", label: "Open"},
	{value: "Closed", label: "Closed"},
	{value: "Archived", label: "Archived"}
    ],
	status2: [    
{value: "Active", label: "Active"},
	{value: "Inactive", label: "Inactive"}
    ],
	reason: [    
{value: "Damage Repair", label: "Damage Repair"},
	{value: "Cleaning", label: "Cleaning"},
	{value: "Unpaid Rent", label: "Unpaid Rent"},
	{value: "Unpaid Utilities", label: "Unpaid Utilities"},
	{value: "Other", label: "Other"}
    ],
	status2: [    
{value: "Pending", label: "Pending"},
	{value: "Approved", label: "Approved"},
	{value: "Rejected", label: "Rejected"}
    ],
	refundMethod: [    
{value: "Cash", label: "Cash"},
	{value: "Bank Transfer", label: "Bank Transfer"},
	{value: "Credit Card", label: "Credit Card"},
	{value: "Mobile Money", label: "Mobile Money"},
	{value: "Check", label: "Check"}
    ],
	status2: [    
{value: "Pending", label: "Pending"},
	{value: "Completed", label: "Completed"},
	{value: "Failed", label: "Failed"}
    ],
	status2: [    
{value: "Pending", label: "Pending"},
	{value: "Held", label: "Held"},
	{value: "Refunded", label: "Refunded"},
	{value: "Partially Refunded", label: "Partially Refunded"},
	{value: "Forfeited", label: "Forfeited"}
    ],
	managedBy: [    
{value: "Haven", label: "Haven"},
	{value: "Other", label: "Other"}
    ],
	houseStatus: [    
{value: "Vacant", label: "Vacant"},
	{value: "Occupied", label: "Occupied"}
    ],
	readingType: [    
{value: "Manual", label: "Manual"},
	{value: "Automated", label: "Automated"},
	{value: "Estimated", label: "Estimated"}
    ],
	meterType: [    
{value: "Residential", label: "Residential"},
	{value: "Commercial", label: "Commercial"},
	{value: "Industrial", label: "Industrial"},
	{value: "Irrigation", label: "Irrigation"}
    ],
	status2: [    
{value: "Active", label: "Active"},
	{value: "Inactive", label: "Inactive"},
	{value: "Faulty", label: "Faulty"},
	{value: "Removed", label: "Removed"}
    ],
	paymentMethod: [    
{value: "Cash", label: "Cash"},
	{value: "Card", label: "Card"},
	{value: "Bank", label: "Bank"},
	{value: "Mobile Money", label: "Mobile Money"},
	{value: "Online", label: "Online"}
    ],
	paymentStatus: [    
{value: "Unpaid", label: "Unpaid"},
	{value: "Partially Paid", label: "Partially Paid"},
	{value: "Paid", label: "Paid"},
	{value: "Overdue", label: "Overdue"},
	{value: "Cancelled", label: "Cancelled"}
    ],
	appliesTo: [    
{value: "Renter", label: "Renter"},
	{value: "Non_Renter", label: "Non_Renter"},
	{value: "Commercial", label: "Commercial"},
	{value: "General", label: "General"}
    ],
	isWater: [    
{value: "1", label: "Yes"},
	{value: "0", label: "No"}
    ],
	role: [    
{value: "Admin", label: "Admin"},
	{value: "Reader", label: "Reader"},
	{value: "Billing", label: "Billing"},
	{value: "CustomerService", label: "CustomerService"}
    ],

    exportFormats: {
        print: {
			label: 'Print',
            icon: 'pi pi-print',
            type: 'print',
            ext: 'print',
        },
        pdf: {
			label: 'Pdf',
			
            icon: 'pi pi-file-pdf',
            type: 'pdf',
            ext: 'pdf',
        },
        excel: {
			label: 'Excel',
            icon: 'pi pi-file-excel',
            type: 'excel',
            ext: 'xlsx',
        },
        csv: {
			label: 'Csv',
            icon: 'pi pi-table',
            type: 'csv',
            ext: 'csv',
        },
    },
    
}